export default {
    language: "简体中文",
    StripeSuccess: {
        loading: "正在处理您的支付...",
        successMessage: "您的订阅已成功激活！",
        processingError: "支付处理失败，请联系我们",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "邮箱",
            createdAt: "创建时间",
            noRecord: "无记录",
            loginTime: "登录时间",
        },
        orders: {
            title: "订单历史",
            loading: "加载中...",
            refresh: "刷新",
            orderAmount: "金额",
            points: "积分",
            createdAt: "创建时间",
            orderType: "类型",
            status: "状态",
            noOrders: "暂无订单",
            goToSubscription: "前往购买",
            freeCredit: "免费",
            paidCredit: "付费",
            queryOrderFailed: "查询订单失败",
            statusPaid: "已支付",
            statusPending: "待支付",
            statusCancelled: "已取消",
            statusDeactivated: "已失效",
            checkoutUrlNotAvailable: "获取支付链接失败",
            verifyingPayment: "验证支付状态...",
            paymentSuccess: "支付成功",
            paymentPending: "订单待支付，请完成支付",
            paymentFailed: "支付失败或已取消",
            paymentStatus: "支付状态",
            paymentStatusDescription: "您是否已完成支付？",
            cancelPayment: "取消支付",
            completedPayment: "已完成支付",
            warning: "警告",
            confirmCancelOrder: "确定要取消当前订单吗？此操作不可撤销。",
            cancel: "取消",
            confirm: "确认",
            cancellingOrder: "正在取消订单...",
            orderCancelledSuccess: "订单已取消",
            cancelOrderFailed: "取消订单失败",
            checkOrderStatusFailed: "查询订单状态失败",
            promptClick: "点击\"待支付\"状态可以继续支付",
        }
    },
    Terms: {
        "tabs": {
            "terms": "服务条款",
            "privacy": "隐私政策",
            "cookies": "Cookie 政策"
        },
        "lastUpdated": "最后更新：2025年05月20日",
        "terms": {
            "sections": [
                {
                    "title": "1. 简介",
                    "description": "欢迎使用ClixMagicAI。使用我们的服务即表示您同意这些服务条款。请仔细阅读。"
                },
                {
                    "title": "2. 服务描述",
                    "description": "ClixMagicAI提供AI驱动的工具，用于从图像、视频和PDF中移除水印。我们的服务适用于以下合法用途：",
                    "items": [
                        "移除您自己内容中的水印",
                        "移除您拥有适当权利修改的内容中的水印",
                        "教育和研究目的"
                    ]
                },
                {
                    "title": "3. 用户责任",
                    "description": "使用ClixMagicAI，即表示您同意：",
                    "items": [
                        "仅上传您拥有或有适当权利修改的内容",
                        "不将我们的服务用于任何非法目的或违反任何法律",
                        "不尝试绕过我们的安全措施或使用限制",
                        "不使用我们的服务侵犯他人的知识产权"
                    ]
                },
                {
                    "title": "4. 账户条款",
                    "description": "您可能需要创建一个账户才能使用我们服务的某些功能。为了登录，您可以选择使用Google或GitHub账号。您负责：",
                    "items": [
                        "维护您账户的安全",
                        "在您账户下发生的所有活动",
                        "提供准确的账户信息（包括但不限于头像、邮箱、用户名和用户ID）"
                    ]
                },
                {
                    "title": "5. 免费和付费服务",
                    "description": "ClixMagicAI提供免费基础配额和灵活的积分购买选项，用于访问我们的去水印功能：",
                    "items": [
                        "基础配额：每位用户每天将自动获得3个免费积分，可用于处理内容",
                        "积分消耗规则：图片去水印每次消耗1积分，视频去水印每次消耗3积分",
                        "积分购买：您可以选择购买积分包以获得更多使用次数，所有购买的积分永久有效，无过期限制",
                        "退款政策：由于数字服务的即时性和虚拟性，积分一旦购买成功，概不退款"
                    ]
                },
                {
                    "title": "6. 知识产权",
                    "description": "ClixMagicAI服务，包括所有由我们创建的软件、设计和内容，均为我们的知识产权。未经许可，您不得复制、修改或基于我们的服务创建衍生作品。"
                },
                {
                    "title": "7. 责任限制",
                    "description": "ClixMagicAI\"按原样\"提供服务，不提供任何形式的保证。我们对因您使用我们的服务而产生的任何损害不承担责任。"
                },
                {
                    "title": "8. 条款变更",
                    "description": "我们可能随时修改这些条款。在条款变更后继续使用ClixMagicAI即表示您接受修订后的条款。"
                },
                {
                    "title": "9. 终止",
                    "description": "如果我们认为您的行为违反了这些条款或对其他用户、我们或第三方有害，我们保留立即终止或暂停您访问我们服务的权利，而无需事先通知。"
                },
                {
                    "title": "10. 适用法律",
                    "description": "这些条款应受我们公司注册地管辖法律的约束，而不考虑其法律冲突规定。"
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. 简介",
                    "description": "在ClixMagicAI，我们重视您的隐私并致力于保护您的个人数据。本隐私政策解释了当您使用我们的网站和服务时，我们如何收集、使用和保护您的信息。通过访问我们的网站或使用任何服务，即表示您接受本政策所述的数据处理方式。我们遵守适用的数据保护法规。"
                },
                {
                    "title": "2. 我们收集的信息",
                    "description": "我们可能收集以下类型的信息：",
                    "items": [
                        { "bold": "账户信息", "text": "通过Google或GitHub登录时提供的用户头像、电子邮件地址、用户名和用户ID" },
                        { "bold": "使用数据", "text": "关于您如何使用我们的服务的信息，包括访问的功能和使用时间" },
                        { "bold": "上传内容", "text": "您上传处理的图像、视频或PDF" },
                        { "bold": "支付信息", "text": "购买订阅时的支付信息（由Creem/Stripe/PayPal等第三方支付网关安全处理，我们仅保留支付状态记录）" },
                        { "bold": "技术数据", "text": "IP地址、浏览器类型、设备信息" }
                    ]
                },
                {
                    "title": "3. 我们如何使用您的信息",
                    "description": "我们使用您的信息：",
                    "items": [
                        { "text": "提供、维护和改进我们的服务" },
                        { "text": "处理和完成交易" },
                        { "text": "发送技术通知和支持消息" },
                        { "text": "回应您的评论和问题" },
                        { "text": "分析使用模式以增强用户体验，并仅在实现服务目的所需的范围内处理个人数据" },
                        { "text": "确保个人数据的存储期限不超过必要时间" },
                        { "text": "防止欺诈或非法活动" }
                    ]
                },
                {
                    "title": "4. 数据安全",
                    "description": "我们实施符合行业标准的安全措施保护您的个人信息：",
                    "items": [
                        { "text": "AES-256加密传输和存储中的文件" },
                        { "text": "敏感数据采用零知识架构处理" },
                        { "text": "每日安全日志审计和漏洞扫描" },
                        { "text": "员工访问权限遵循最小特权原则" }
                    ]
                },
                {
                    "title": "5. 数据共享",
                    "description": "我们不出售您的个人信息。我们可能与以下方共享信息：",
                    "items": [
                        { "bold": "服务提供商", "text": "仅限于提供特定服务所必需的数据处理（如CloundFlare云存储、Creem/Stripe/PayPal等第三方支付网关），且需签署数据处理协议" },
                        { "bold": "法律要求", "text": "当收到有效的传票、法院命令或适用于我们的其他法律程序时" }
                    ]
                },
                {
                    "title": "6. 您的权利",
                    "description": "根据您所在地区的有效法律，您可能享有以下权利：",
                    "items": [
                        { "text": "访问您的个人数据副本" },
                        { "text": "更正不准确或不完整的信息" },
                        { "text": "删除数据的权利（'被遗忘权'），除非我们有合法理由保留" },
                        { "text": "反对或限制特定类型的数据处理" },
                        { "text": "数据可移植权，可要求转移您的数据" }
                    ]
                },
                {
                    "title": "7. 儿童隐私",
                    "description": "我们的服务不面向16岁以下未成年人。根据《通用数据保护条例》(GDPR)第8条，16岁以下儿童的同意必须由父母或监护人作出。如果您知道16岁以下未成年人向我们提供了个人信息，请立即通过support@clixmagic.com联系我们。"
                },
                {
                    "title": "8. 本政策的变更",
                    "description": "我们可能会定期更新本隐私政策。我们会通过在此页面上发布新政策并更新\"最后更新\"日期来通知您任何重大变更。对于重大变更，我们将通过电子邮件或其他显著的方式通知用户。"
                },
                {
                    "title": "9. 联系我们",
                    "description": "如果您对本隐私政策有任何问题，请通过support@clixmagic.com联系我们。如果您认为您的数据被不当处理或有任何疑虑，也欢迎随时联系我们。"
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. 什么是Cookie",
                    "description": "Cookie是当您访问网站时放置在您的计算机或移动设备上的小型文本文件。它们允许网站识别您的设备并记住您是否之前访问过该网站。"
                },
                {
                    "title": "2. 我们如何使用Cookie",
                    "description": "ClixMagicAI使用Cookie用于多种目的：",
                    "items": [
                        { "bold": "必要Cookie", "text": "对于我们网站的基本功能（如会话管理和安全功能）是必需的" },
                        { "bold": "偏好Cookie", "text": "记住您的设置和偏好以增强您的体验，例如通过Google或GitHub登录后记住您的头像、用户名等信息" },
                        { "bold": "分析Cookie", "text": "通过收集匿名信息帮助我们了解访问者如何与我们的网站互动" },
                        { "bold": "营销Cookie", "text": "跟踪您的浏览习惯以提供与您兴趣相关的广告" }
                    ]
                },
                {
                    "title": "3. 我们使用的Cookie类型",
                    "subsection": [
                        {
                            "title": "3.1 必要Cookie",
                            "description": "这些Cookie对网站正常运行是必需的。它们启用核心功能，如安全、网络管理和账户访问（包括Google和GitHub登录）。您可以设置浏览器阻止这些Cookie，但网站的某些部分可能无法正常工作。"
                        },
                        {
                            "title": "3.2 性能和分析Cookie",
                            "description": "这些Cookie通过收集匿名信息帮助我们了解访问者如何与我们的网站互动。我们使用这些数据改进我们的网站和服务。这些Cookie不收集可识别访问者身份的信息。"
                        },
                        {
                            "title": "3.3 功能Cookie",
                            "description": "这些Cookie允许我们的网站记住您做出的选择（如语言偏好或登录状态），以提供增强的个性化功能，比如记住您通过Google或GitHub登录的状态。"
                        },
                        {
                            "title": "3.4 定向和广告Cookie",
                            "description": "这些Cookie用于向访问者显示相关广告并跟踪我们广告活动的效果。请注意，由于我们网站主要依赖于第三方登录（Google和GitHub），这类Cookie主要用于提升用户体验而非直接营销。"
                        }
                    ]
                },
                {
                    "title": "4. 管理Cookie",
                    "description": "您可以通过多种方式控制和管理Cookie。大多数网络浏览器允许您管理Cookie偏好。您可以：",
                    "items": [
                        { "text": "从您的设备删除Cookie" },
                        { "text": "通过激活允许您拒绝所有或部分Cookie的浏览器设置来阻止Cookie" },
                        { "text": "设置浏览器在您收到Cookie时通知您" }
                    ]
                },
                {
                    "title": "5. 第三方Cookie",
                    "description": "某些Cookie是由第三方在我们网站上放置的。这些第三方可能包括分析服务（如Google Analytics）和广告网络。由于Cookie的工作方式（Cookie只能由最初设置它们的一方访问），我们不控制这些第三方Cookie的使用，也无法访问它们。对于通过Google和GitHub登录的用户，我们将确保遵循这些平台的隐私指南处理相关信息。"
                },
                {
                    "title": "6. 本Cookie政策的更新",
                    "description": "我们可能会不时更新本Cookie政策，以反映技术、法规或我们业务实践的变化。任何变更都将在此页面上发布，并更新修订日期。"
                },
                {
                    "title": "7. 联系我们",
                    "description": "如果您对我们使用Cookie有任何问题，请通过support@clixmagic.com联系我们。"
                }
            ]
        }
    },
    Recommend:{
        title: "",
        desc: "",
        collapse: "收起",
        expand: "展开",
        products: [
            {
                "title": "",
                "desc": "",
                "image": "",
                "link": ""
            },
        ]
    },
    UserFeedback: {
        title: "用户心声",
        feedback: "聆听来自全球创作者与专业人士对我们的AI图像处理技术的真实评价。",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "林先生",
                profession: "视频剪辑师 & 自媒体内容创作者",
                rating: 5,
                comment: "太牛了！ClixMagicAI处理速度超快的！上传带水印视频，几分钟就能输出无水印版本，画质完全没损失，简直是去水印必备神器！"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "苏女士",
                profession: "社交媒体运营专家",
                rating: 5,
                comment: "ClixMagicAI拯救了我的Ins素材库！复杂水印也能精准识别，边缘处理比之前用的软件细腻多了，视觉效果更自然。"
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "陈先生",
                profession: "短视频内容制作人",
                rating: 5,
                comment: "ClixMagicAI去水印超方便，通勤路上处理TikTok素材，到公司直接下载高清版，效率翻倍！是自媒体工作者的福音。"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "黄先生",
                profession: "平面设计师 & 视觉创意总监",
                rating: 5,
                comment: "作为设计师我很满意！处理客户提供的带Logo样图时，背景纹理修复得很自然，毫无PS痕迹，节省大量后期时间。"
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Emily女士",
                profession: "自由职业数字内容创作者",
                rating: 5,
                comment: "发现宝藏啦！会员价比市面上其他去水印产品便宜很多，但去水印效果反而更好，特别是处理渐变透明水印时优势明显。"
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Robertson先生",
                profession: "企业培训课程制作人",
                rating: 5,
                comment: "ClixMagicAI不用安装真方便！公司电脑权限限制装不了软件，现在用浏览器就能处理课程素材，随时随地都能用。"
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "周女士",
                profession: "家庭主妇 & 社群图文编辑者",
                rating: 5,
                comment: "操作界面简单到姥姥都会用！没有时间学习PS专业软件的一定要试一试ClixMagicAI，十分适合我这种技术小白用户。哈哈~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Johnson先生",
                profession: "电商视觉策划",
                rating: 5,
                comment: "ClixMagicAI太强大啦，可以去除图片、视频、小物件、路人、文字等等，功能全面，推荐给大家~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "方女士",
                profession: "摄影爱好者 & 网络内容分享者",
                rating: 5,
                comment: "哇~终于找到不破坏画质的去水印工具了！像魔法一样神奇~p图不再是难题！强烈推荐！！！"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Williams先生",
                profession: "在线教育讲师",
                rating: 5,
                comment: "水印位置记忆功能超实用！处理系列课程视频时不用反复框选，节省至少半小时工作量，大大提升我的教学准备效率。"
            }
        ]
    },
    Order: {
        purchasePoints: "购买积分",
        subtitle: "选择合适的积分套餐，享受高质量的水印去除服务",
        loginReminderDesc: "登录后即可选择并购买积分",
        freeTag: "免费",
        freePlan: "免费计划",
        autoActivated: "登录后自动激活",
        points: "积分",
        autoIncluded: "免费赠送",
        discount: "优惠",
        purchase: "立即购买",
        paymentStatusDescription: "您是否已完成支付？",
        paymentNotCompleted: "支付未完成",
        queryOrderFailed: "查询订单状态失败",
        cancelPayment: "取消支付",
        completedPayment: "已完成支付",
        warning: "警告",
        confirmCancelOrder: "确定要取消当前订单吗？此操作不可撤销。",
        cancel: "取消",
        confirm: "确认",
        selectProductFirst: "请先选择一个套餐",
        creatingOrder: "正在创建订单...",
        orderCreated: "订单创建成功",
        createOrderFailed: "创建订单失败",
        checkoutUrlNotAvailable: "获取支付链接失败",
        cancellingOrder: "正在取消订单...",
        orderCancelledSuccess: "订单已取消",
        cancelOrderFailed: "取消订单失败",
        verifyingPayment: "正在验证支付状态...",
        paymentSuccess: "支付成功",
        paymentPending: "订单待支付，请完成支付",
        paymentFailed: "支付失败或已取消",
        checkOrderStatusFailed: "查询订单状态失败",
        quickStart: "快速体验",
        shortTerm: "短期使用",
        recommended: "推荐",
        bestValue: "最具性价比",
    },
    Login: {
        title: "登录",
        subtitle: "使用社交账号快速登录",
        memberTip: "登录后可享受更多功能",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "使用 GitHub 账号登录"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "使用 Google 账号登录"
            }
        ],
        error: {
            serverError: "服务器错误，请稍后再试",
            networkError: "网络错误，请检查网络连接"
        }
    },
    OAuthCallback: {
        loading: "正在处理登录请求",
        pleaseWait: "请稍等，正在验证登录信息...",
        error: "登录失败",
        backToHome: "返回首页",
        success: "登录成功",
        redirecting: "正在跳转到首页..."
    },
    FAQ: {
        title: "ClixMagicAI 使用指南与常见问题",
        prompt: "遇到任何问题或有任何疑问？随时联系我们：support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "什么是 ClixMagicAI 以及它是如何工作的？",
                answer: "ClixMagicAI 是一款先进的 AI 驱动的水印去除工具。它支持自动识别图片和视频中的水印，并提供手动标注水印位置的功能。对于图片，支持多种格式转换并确保高质量输出；对于视频，能够处理静态、动态甚至形状变化的水印。"
            },
            {
                id : 2,
                question: "ClixMagicAI 提供免费使用吗？",
                answer: "是的，我们提供每日3积分的基础免费服务！您可以用来处理图片（每次消耗1积分）或视频（每次消耗3积分）。此外，您还可以购买额外积分，所购积分永久有效。"
            },
            {
                id : 3,
                question: "我可以购买额外的积分吗？",
                answer: "当然可以！除了每日赠送的3个免费积分外，您还可以通过我们的购买选项获取额外积分。所购买的积分将永久有效，没有过期日。"
            },
            {
                id : 4,
                question: "支持哪些文件格式？",
                answer: "对于图片，我们支持PNG、JPEG、JPG、WEBP、HEIC和HEIF格式，其中HEIC和HEIF将自动转换为PNG。视频方面，支持包括MP4、MOV在内的多种格式。"
            },
            {
                id : 5,
                question: "如何保护我的隐私？",
                answer: "在ClixMagicAI，我们高度重视用户隐私。所有上传的文件都将被加密处理，且在处理完成后的24小时内自动删除。我们不会保存任何用户文件或相关信息。"
            },
            {
                id : 6,
                question: "我可以怎样登录ClixMagicAI？",
                answer: "我们支持通过GitHub或Google账号快速登录，确保您的账户安全同时简化注册流程。"
            },
            {
                id : 7,
                question: "处理速度有多快？",
                answer: "得益于我们的高性能服务器和优化的AI算法，大多数图片去水印任务可以在10秒内完成，而视频去水印则最快仅需1分钟。实际时间可能会根据文件大小和复杂度有所不同。"
            },
            {
                id : 8,
                question: "处理后的效果如何？",
                answer: "我们的AI模型经过大量训练，能够智能地去除图片和视频中的水印，同时保持原始内容的质量。无论是自动识别还是手动标注的水印，都能得到有效的去除，确保最终结果自然无痕。"
            },
            {
                id : 9,
                question: "每个任务的有效期是多久？",
                answer: "一旦任务完成，处理后的文件将在ClixMagicAI上保留24小时，以便用户下载。过期后，文件将自动从我们的服务器中删除以保护您的隐私。"
            },
            {
                id : 10,
                question: "最大文件大小限制是多少？",
                answer: "我们接受的最大图片文件大小为10MB，视频文件最大为100MB。超出此限制的文件可能需要先进行压缩或裁剪才能上传。"
            }
        ]
    },
    ProductAdv: {
        title: "探索ClixMagicAI的强大功能：",
        advs: [
            {
                title: "AI智能识别引擎：自动定位各类干扰元素",
                desc: "基于深度学习算法，自动识别图片/视频中的水印、文字、人脸及复杂背景元素，无需手动标记。支持Instagram、TikTok等平台格式，严格保护隐私数据不外泄。",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "去水印"
            },
            {
                title: "图片净化大师：秒除Logo/日期戳，画质无损",
                desc: "精准擦除品牌水印、拍摄日期、贴纸等干扰元素。AI自动修复背景纹理，处理后图片如原图般自然，完美适配社交媒体发帖需求。",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "去水印"
            },
            {
                title: "动态水印终结者：抹除滚动字幕/平台Logo",
                desc: "一键清除YouTube片尾浮标、TikTok动态水印及滚动字幕。AI智能追踪逐帧处理，输出流畅无卡顿的4K高清视频，支持MP4/MOV等主流格式。",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "去水印"
            }
        ]
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "定价",
            faq: "问题",
        },
        login: "登录",
        userMenu: {
            account: "管理",
            logout: "登出",
            credit: "积分",
            freeCredit: "免费",
            paidCredit: "已购买",
            nextUpdate: "积分下次更新",
            language: "语言",
            theme: "主题",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    Description:{
        title: "ClixMagicAI",
        desc: "一款专业的AI智能去水印工具，支持一键快速处理图片、视频和PDF中的水印，操作简单高效，效果自然无痕。",
        fileTypes: {
            image: '图片去水印',
            pdf: 'PDF去水印',
            video: '视频去水印'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "每日免费体验", icon: "fa-gift" },
            { id: "imageTag", text: "图片水印去除", icon: "fa-image" },
            { id: "videoTag", text: "视频水印去除", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI智能处理", icon: "fa-robot" },
            { id: "noRegTag", text: "登录即用", icon: "fa-user-check" },
        ],
        videoPromt: "即将上线，敬请期待！",
        videoDesc: "我们正在努力开发视频去水印功能，将为您带来更强大的体验。"
    },
    Footer: {
        social: {
            title: "联系我们",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "法律条款",
        terms: [
            {
                id: 1,
                title: "隐私政策",
                link: "/privacy"
            },
            {
                id: 2,
                title: "服务条款",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookie 政策",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI 版权所有。"
    },
    Task: {
        image: {
            imageSupportText: '支持 jpg、jpeg、png、webp、heic、heif 格式，单个文件最大 10MB',
            imageFileTooLarge: '文件大小超过限制（最大 10MB）',
            invalidImageType: '不支持的图片格式，请上传JPG、JPEG、PNG、WEBP、HEIC或HEIF格式',
            imageWillCost: '将消耗：1 积分',
            hiecSupportText: 'HEIC/HEIF格式将在提交时自动转换为PNG格式',
            hiecSuccess: 'HEIC/HEIF格式转换成功',
            hiecFailed: 'HEIC/HEIF格式转换失败',
            processingImageTip: '正在处理您的图片，请稍候...',
            guide: {
                title: '操作指南',
                step1: '上传图片',
                step2: '涂抹水印区域或无需涂抹模型自动识别水印',
                step3: '点击提交'
            }
        },
        common: {
            remaining: '剩余积分',
            nextUpdate: '积分下次更新',
            handleError: '处理文件时出错，请尝试其他文件',
            uploadFailed: '文件上传失败',
        dragText: '拖拽文件到这里或',
        clickText: '点击上传',
        loginRequired: '请先登录后再上传文件',
            noRemainingTasks: '你的积分已使用完毕',
        loginNow: '立即登录',
        upgradeNow: '立即购买积分',
        taskSubmitSuccess: '任务提交成功',
            taskSubmitError: '任务提交失败',
            taskRetrySuccess: '任务重试提交成功！',
            taskRetryError: '任务重试提交失败！',
            processing: '处理中',
            submit: '提交',
            waiting: '等待中',
            completed: '已完成',
            failed: '失败',
            cancelled: '取消',
            url_not_found: '获取链接失败',
            deleted: '已删除',
            refreshSuccess: '任务列表已刷新',
            refreshFailed: '刷新任务列表失败',
            deleteSuccess: '任务删除成功',
            deleteFailed: '任务删除失败',
            waitingForCompletion: '请等待当前任务完成后再重试',
            loadOriginalImageFailed: '加载原图失败，请重试',
            downloadFailed: '下载失败',
            startingDownload: '开始下载...',
            noTasks: '暂无任务',
            refresh: '刷新',
            sort: '排序',
            noFilterTasks: '暂无{filter}任务',
            compare: '查看对比',
            originalImage: '原图',
            processedImage: '处理后',
            dragToCompare: '👈 左右拖动查看对比 👉',
            cancel: "取消",
            delete: "删除",
            retry: "重试",
            download: "下载",
            createAt: "创建于",
            expiredAt: "过期于",
        },
        video: {
            videoSupportText: '支持 mp4、mov、avi、mkv 格式，单个文件最大 100MB',
            videoFileTooLarge: '文件大小超过限制（最大 100MB）',
            invalidVideoType: '不支持的视频格式，请上传MP4、MOV、AVI或MKV格式',
            videoWillCost: '将消耗：3 积分',
            processingVideoTip: '正在处理您的视频，请稍候...',
            guide: {
                step1: '上传视频',
                step2: '选择对应的水印类型进行框定水印区域',
                step3: '点击提交'
            },
            annotationTools: '水印标注工具',
            selectType: '选择水印类型',
            deleteAnnotation: '删除标注',
            clearAllAnnotations: '清除所有标注',
            annotationHelp: '标注帮助',
            dragTip: '拖动以绘制水印区域',
            resizeTip: '调整大小以匹配水印',
            moveTip: '可以移动已创建的标注',
            processing: '处理中',
            submit: '提交',
            taskSubmitSuccess: '任务提交成功',
            taskSubmitError: '任务提交失败',
            retryTaskTip: '重试任务提交成功',
            retryFailed: '重试任务失败',
            uploadFailed: '上传失败',
            staticWatermarkDesc: '适用于固定位置的静态水印',
            normalWatermarkDesc: '适用于普通的固定水印',
            dynamicWatermarkDesc: '适用于变化的动态水印',
            moveWatermarkDesc: '适用于需要移动的水印'
        },
    },
    Router: {
        home: "首页",
        terms: "服务条款",
        privacy: "隐私政策",
        cookie: "Cookie政策",
        user: "用户中心",
    },
}